<template>
  <div id="result-table">
    <vs-table max-items="30" pagination :data="datas" no-data-text="กำลังรอข้อมูล...">
      <template slot="thead">
        <vs-th>ลำดับ</vs-th>
        <vs-th>งวดวันที่</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ index+1 }}
          </vs-td>
          <vs-td>
            {{ tr.lotto_date }}
          </vs-td>
          <vs-td>
            <vs-button class="float-right" color="success" icon-pack="feather" icon="icon-edit" @click="info(tr.lotto_date)">รายละเอียด</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import LottoService from "@/services/lottoService"

export default {
  data() {
    return {
      items: []
    }
  },
  computed: {
    datas() {
      return this.items
    }
  },
  methods: {
    deleteData() {

    },
    info(lotto_date) {
      this.$router.push({ name: 'admin-results', params: { resultDate: lotto_date } })
    },
    loadDrawdate() {
      LottoService.getDrawdate().then((response)=>{
        if(response.status === 'success') {
          this.items = response.date
        }
      })
    }
  },
  created() {
    this.loadDrawdate()
  }
}
</script>
